export const MAP_SETTINGS_LAYERED_MAP_SETTINGS_SUBMITTED = 'MAP_SETTINGS_LAYERED_MAP_SETTINGS_SUBMITTED';
